import * as React from "react";
import { pipe } from "fp-ts/function";
import { record } from "fp-ts";
import { MenuItem } from "@mui/material";
import { Select } from "../form/Select";
import { recordOrdFromNumericMap } from "../../utils/fp";
import { Sex, sexMessages } from "../../domain/user";
import { messages } from "../../utils/i18n/i18n";
import { useTranslation } from "../../utils/i18n/lang";
import { InputProps } from "../form/form";

interface Props extends InputProps {}
// TODO dev mode cries for ref...
export const SexSelect = (p: Props) => {
    const m = useTranslation(msg);
    const sexM = useTranslation(sexMessages);

    return (
        <Select {...p} label={m.sex} fullWidth>
            {pipe(
                sexM,
                record.collect(sexSelectOrd)((sex, label) => (
                    <MenuItem key={sex} value={sex}>
                        {label}
                    </MenuItem>
                ))
            )}
            {p.required ? null : (
                <MenuItem key={"none"} value={""}>
                    <em>{m.none}</em>
                </MenuItem>
            )}
        </Select>
    );
};

const msg = messages(
    {
        sex: "Sex",
        none: "unisex",
    },
    {
        cs: {
            sex: "Pohlaví",
            none: "unisex",
        },
    }
);

const sexSelectOrd = recordOrdFromNumericMap<Sex>({
    M: 1, // males are presented more frequently
    F: 2,
});
